import CustomTextarea from "@/components/Textarea";
import { Box } from "@chakra-ui/react";
import { colors } from "goi_common";
import { useCallback } from "react";

import { useRecoilState } from "recoil";
import { reviewBadContentState, reviewContentState } from "@/atoms/funeralReviewState";
function ReviewTextareaSection() {
  const [reviewContent, setReviewContent] = useRecoilState(reviewContentState);
  const onChange = useCallback(
    (val: string) => {
      setReviewContent(val);
    },
    [reviewContent, setReviewContent],
  );

  const [badReviewContent, setBadReviewContent] = useRecoilState(reviewBadContentState);
  const onBadChange = useCallback(
    (val: string) => {
      setBadReviewContent(val);
    },
    [badReviewContent, setBadReviewContent],
  );
  return (
    <Box>
      <Box className="subtitle1_sb" mb="4px">
        좋았던 점을 알려주세요.
      </Box>
      <Box className="body2">
        상주님의 정성스러운 후기는 파트너가 더 큰 자부심을 느끼고, 다른 상주님이 회사를 신뢰하는데
        도움이 됩니다.
      </Box>

      <Box mt="24px" mb="40px">
        <CustomTextarea
          value={reviewContent}
          onChange={(val) => onChange(val)}
          removeValue={() => setReviewContent("")}
          textareaProps={{
            className: "body2 gray900",
            width: "100%",
            height: "252px",
            background: colors.gray50,
            borderRadius: "8px",
            outline: "none",
            border: "none",
            resize: "none",
            padding: "16px 20px",
          }}
          placeholderProps={{
            placeholder: (
              <Box>
                <Box className="body2 gray500">
                  좋았던 점을 자유롭게 남겨주세요.<div>(최소 10자)</div>
                </Box>
                <br />
                <Box className="body2 gray400">
                  서비스 이용 없이 후기를 허위로 작성할 경우, 통보 없이 후기가 삭제될 수 있습니다.
                </Box>
              </Box>
            ),
            sx: {
              padding: "16px 20px",
            },
          }}
        />
      </Box>

      <Box className="subtitle1_sb" mb="4px">
        아쉬웠던 점을 알려주세요.
      </Box>
      <Box className="body2">
        상주님의 정성스러운 후기는 파트너가 더 큰 자부심을 느끼고, 다른 상주님이 회사를 신뢰하는데
        도움이 됩니다.
      </Box>

      <Box mt="24px">
        <CustomTextarea
          value={badReviewContent}
          onChange={(val) => onBadChange(val)}
          removeValue={() => setBadReviewContent("")}
          textareaProps={{
            className: "body2 gray900",
            width: "100%",
            height: "252px",
            background: colors.gray50,
            borderRadius: "8px",
            outline: "none",
            border: "none",
            resize: "none",
            padding: "16px 20px",
          }}
          placeholderProps={{
            placeholder: (
              <Box>
                <Box className="body2 gray500">아쉬웠던 점을 자유롭게 남겨주세요.</Box>
                <br />
                <Box className="body2 gray400">
                  서비스 이용 없이 후기를 허위로 작성할 경우, 통보 없이 후기가 삭제될 수 있습니다.
                </Box>
              </Box>
            ),
            sx: {
              padding: "16px 20px",
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default ReviewTextareaSection;
